import React, { Fragment } from 'react';
import Navbar from 'components/@layout/NavBar';
import AppBar from 'components/@layout/AppBar';
import { ModuleProps } from 'types';
import Button from '@material-ui/core/Button';
import NavigationIcon from '@material-ui/icons/Navigation';
import { useHistory } from 'react-router-dom';

export const HeaderBar: React.FC<ModuleProps> = props => {
  const history = useHistory();

  const handleClick = (): void => {
    history.push('/welcome', {
      redirect: { pathname: history.location.pathname, search: history.location.search }
    });
  };

  return (
    <Fragment>
      <AppBar {...props}>
        <Button
          onClick={handleClick}
          aria-label="View Navigation Map"
          variant="outlined"
          color="secondary"
          size="large"
          disableElevation
          startIcon={<NavigationIcon />}
        >
          Navigation Map
        </Button>
      </AppBar>
      <Navbar {...props}></Navbar>
    </Fragment>
  );
};

export default HeaderBar;
